import apiClient from "./apiClient";
import { normalizeApiError } from "../utils/apiError";

function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function extractData(payload) {
  return payload?.data ?? payload;
}

const sellingMasterService = {
  async getSellingMasters(params = {}) {
    try {
      const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const response = await apiClient.get("/selling-master", {
        params: cleanParams,
      });

      const payload = response?.data || {};
      const dataRoot = extractData(payload);
      const items = toArray(dataRoot?.data || dataRoot?.items || dataRoot);
      const meta = dataRoot?.meta || payload?.meta || {};

      return {
        items,
        meta: {
          page: Number(meta?.page || cleanParams.page || 1),
          limit: Number(meta?.limit || cleanParams.limit || 10),
          total: Number(meta?.total || meta?.totalItems || items.length || 0),
          totalPages: Number(meta?.totalPages || 1),
        },
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getSellingMasterById(id) {
    if (!id) throw new Error("Selling Master ID is required");

    try {
      const response = await apiClient.get(`/selling-master/${id}`);
      const payload = response?.data || {};
      return extractData(payload);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async createSellingMaster(data) {
    try {
      const response = await apiClient.post("/selling-master", data);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async updateSellingMaster(id, data) {
    if (!id) throw new Error("Selling Master ID is required");

    try {
      const response = await apiClient.patch(`/selling-master/${id}`, data);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async deleteSellingMaster(id) {
    if (!id) throw new Error("Selling Master ID is required");

    try {
      const response = await apiClient.delete(`/selling-master/${id}`);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async toggleReceivedStatus(id, isReceived) {
    if (!id) throw new Error("Selling Master ID is required");
    try {
      const response = await apiClient.patch(`/selling-master/${id}`, { isReceived });
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
};

export default sellingMasterService;
